var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"grey lighten-4"},[_c('Navbar'),_c('v-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }